	export enum PaymentMethodEnum {
		Cash = 1,
		Amex = 2,
		Check = 3,
		Discover = 5,
		MasterCard = 6,
		Visa = 7,
		StoreCredit = 8,
		FinanceCredit = 9,
		HoCheck = 10,
		Invoiced = 11,
		FlexCard = 12,
		CreditCard = 13,
	}
